import { Xmark } from "@gravity-ui/icons";
import { Alert, Button, Flex, Icon, Text } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import { PromotionAwardRequestDtoTypeEnum } from "definitions/poizon-bff";
import { useCallback } from "react";

import { getPromotionAwardRequest } from "../../store/fetchers/getPromotionAwardRequest";
import { PromotionSection } from "./components/PromotionSection";

interface PromotionContentProps {
  isModal?: boolean;
  onClose?: () => void;
}

export const PromotionContent = ({
  isModal,
  onClose,
}: PromotionContentProps) => {
  const getPromotionAward = useAction(getPromotionAwardRequest);
  const [isLoadingPromotionButton] = useAtom(
    getPromotionAwardRequest.isLoadingAtom,
  );
  const [promotionAward] = useAtom(getPromotionAwardRequest.dataAtom);

  const handleCheckAward = useCallback(async () => {
    const response = await getPromotionAward(
      PromotionAwardRequestDtoTypeEnum.Telegram,
    );

    if (!response && onClose) onClose();
  }, [getPromotionAward, onClose]);

  return (
    <Flex
      direction={"column"}
      alignItems={"center"}
      gap={8}
      style={{ padding: 20, position: "relative" }}
    >
      {isModal && (
        <div style={{ position: "absolute", right: 4, top: 4 }}>
          <Button view="flat" onClick={onClose}>
            <Icon data={Xmark} />
          </Button>
        </div>
      )}

      <Flex direction={"column"} alignItems={"center"} gap={4}>
        <Text
          variant="subheader-3"
          color="brand"
          style={{ textAlign: "center" }}
        >
          Получите 5 дней бесплатного доступа!
        </Text>
        <Text style={{ maxWidth: 400, textAlign: "center" }}>
          Привяжите Ваш аккаунт Telegram и разрешите нашему боту писать Вам,
          чтобы получить бесплатную подписку на 5 дней к нашему сервису.
        </Text>
      </Flex>
      <PromotionSection />
      <Flex direction={"column"} width={"100%"} gap={3}>
        {promotionAward && (
          <Alert
            style={{ width: "100%" }}
            theme="danger"
            message={promotionAward?.message}
          />
        )}
        <Button
          width="max"
          size="l"
          view="action"
          loading={isLoadingPromotionButton}
          onClick={handleCheckAward}
        >
          <Text variant="subheader-1">Проверить и получить подписку</Text>
        </Button>
      </Flex>
    </Flex>
  );
};
